const Range = require('../classes/range')
const satisfies = (version, range, options) => {
  try {
    range = new Range(range, options)
  } catch (er) {
    return false
  }
  return range.test(version)
}
module.exports = satisfies



//////////////////
// WEBPACK FOOTER
// ./~/jsonwebtoken/~/semver/functions/satisfies.js
// module id = 46
// module chunks = 0